import React from "react";
// import {
//   Box,
//   Grid,
//   IconButton,
//   MuiTooltip,
//   KeyboardArrowUpIcon,
//   KeyboardArrowDownIcon,
//   checkObjectLength,
//   Button,
//   AddCircleOutlineIcon,

// } from "../..";

import { Box, Grid, IconButton, Button } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { MuiTooltip } from "../"

// ==================================================================================================================
const TabHeader = ({
  viewMore,
  headerName,
  setViewMore,
  createPermission,
  viewAll,
  viewAllTooltip,
  newName,
  handleNew,
  handleViewAll,
  handleUpload,
  handleDownload,
  headerNameChildren,
  key,
}) => {

  return (
    <Box
      sx={{ width: "100%", padding: 0 }}
      className="background-color radius-p3 tabs-border"
    >
      <Grid container sx={{ alignItems: "center" }}>
        <Grid item md={0.5} lg={0.5} xs={0.5} xl={0.5} sm={0.5}>
          {setViewMore &&
            (viewMore ? (
              <MuiTooltip title="View Less">
                <IconButton
                 aria-label="keyboard-Arrow-Icon"
                  onClick={() => {
                    setViewMore(false);
                  }}
                >
                  <KeyboardArrowUpIcon className="tabs-icon-color" />
                </IconButton>
              </MuiTooltip>
            ) : (
              <MuiTooltip title="View More">
                <IconButton
                 aria-label="keyboard-down-icon"
                  onClick={() => {
                    setViewMore(true);
                  }}
                >
                  <KeyboardArrowDownIcon className="tabs-icon-color" />
                </IconButton>
              </MuiTooltip>
            ))}
        </Grid>

        <Grid item md={2} lg={2} xs={2} xl={2} sm={2}>
         
            <Button
              style={{
                // color: "black",
                border: "none",
                fontSize: "1rem",
              }}
              sx={{
                "& .MuiButton-startIcon": {
                  margin: 0,
                },
              }}
              variant="outlined"
              startIcon={
                <AddCircleOutlineIcon
                  className="tabs-icon-color"
                  sx={{ marginRight: "0.25rem" }}
                />
              }
              onClick={()=>handleNew()}
              className="tabs-icon-color"
            >
              {newName ?? "New"}
            </Button>
          
        </Grid>
        <Grid
          item
          md={headerNameChildren ? 8 : 6.5}
          lg={headerNameChildren ? 8 : 6.5}
          xs={headerNameChildren ? 8 : 6.5}
          xl={headerNameChildren ? 8 : 6.5}
          sm={headerNameChildren ? 8 : 6.5}
        >
          {headerName && (
            <div
             
              className="center pt-2 tabs-header-font-style"
            // style={{
            //     // paddingBottom: '0.5rem',
            //     color: "black",
            // }}
            >
              
              {headerName}
            </div>
          )}
          {headerNameChildren && headerNameChildren}
        </Grid>
        {!Boolean(headerNameChildren) && (
          <Grid item md={1.5} lg={1.5} xs={1.5} xl={1.5} sm={1.5}></Grid>
        )}
        <Grid
          item
          md={1}
          lg={1}
          xs={1}
          xl={1}
          sm={1}
          style={{ display: "flex", justifyContent: "flex-end" }}
          key={headerName}
        >
          {viewAll && (
            <MuiTooltip title={viewAllTooltip}>
              <Button
                style={{
                  color: "white",
                  border: "none",
                  backgroundColor: "#06324a",
                  textTransform: "none",
                }}
                variant="contained"
                onClick={handleViewAll}
                size="small"
              >
                {viewAll}
              </Button>
            </MuiTooltip>
          )}
          {/* {handleUpload && <GridToolbarUpload handleUpload={handleUpload} keyProp={headerName} />}
          {handleDownload && (
            <GridToolbarPageObjectDownload
              handlePageObjectDownload={handleDownload}
            />
          )} */}
        </Grid>
        <Grid item md={0.5} lg={0.5} xs={0.5} xl={0.5} sm={0.5}></Grid>
      </Grid>
    </Box>
  );
};

export default TabHeader;
